module.exports = __webpack_public_path__ + "assets/img/experts-b-1.576ff199.png";